import { OrganizationUserContext } from "contexts/Organization";
import { CheckoutState, SubscriptionContext } from "contexts/Subscription";
import { UserIntegrationsContext } from "contexts/UserIntegrations";
import { useContext } from "react";
import { AddOnItemName, UpgradeDialogSource } from "schemas/dashboard";

const EMAIL_LIMIT_ERROR_FRAGMENT = "remaining messages this month";
const GMAIL_ERROR_FRAGMENT = "Google integration";

export function useEmailLimitUpgrade() {
  const { currentOrg } = useContext(OrganizationUserContext);
  const { setUpgradeDialogSource, setOpenCheckoutDialog } =
    useContext(SubscriptionContext);
  const { setOpenIntegrationDialog, setIntegrationDialogTitle } = useContext(
    UserIntegrationsContext,
  );

  const tryHandleEmailLimitError = (error: unknown): boolean => {
    const message = (error as { message?: string })?.message ?? "";
    if (!message.includes(EMAIL_LIMIT_ERROR_FRAGMENT)) {
      return false;
    }
    if (!currentOrg?.isAutopilotUser) {
      return false;
    }

    setUpgradeDialogSource(UpgradeDialogSource.email_volume_from_autopilot);
    const state: CheckoutState = {
      plan: AddOnItemName.email_volume_pro_monthly,
      source: "Autopilot Email Limit",
      pageSource: window.location.pathname,
    };
    setOpenCheckoutDialog(state);
    return true;
  };

  const tryHandleGmailError = (
    error: unknown,
    title = "Connect Gmail to continue",
  ): boolean => {
    const message = (error as { message?: string })?.message ?? "";
    if (!message.includes(GMAIL_ERROR_FRAGMENT)) {
      return false;
    }
    setIntegrationDialogTitle(title);
    setOpenIntegrationDialog(true);
    return true;
  };

  return { tryHandleEmailLimitError, tryHandleGmailError };
}
